import { render, staticRenderFns } from "./IconAddRounded.vue?vue&type=template&id=09f108d1&scoped=true"
import script from "./IconAddRounded.vue?vue&type=script&lang=js"
export * from "./IconAddRounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f108d1",
  null
  
)

export default component.exports